export const GEOLOCATION_DATA = 'GEOLOCATION_DATA'
export const AUTOCOMPLITE_DATA = 'AUTOCOMPLITE_DATA'
export const SET_CITY_FROM_VALUE = 'SET_CITY_FROM_VALUE'
export const SET_CITY_TO_VALUE = 'SET_CITY_TO_VALUE'
export const CITY_REPLACE_VALUES = 'CITY_REPLACE_VALUES'
export const SET_DEPARTURE_DATE_VALUE = 'SET_DEPARTURE_DATE_VALUE'
export const SELECT_CARGO_TYPE_TOGGLE = 'SELECT_CARGO_TYPE_TOGGLE'
export const SET_CARGO_TYPE_VALUE = 'SET_CARGO_TYPE_VALUE'
export const CHANGE_SIZE_TYPE = 'CHANGE_SIZE_TYPE'
export const SET_OVERALL_VOLUME_PLACES = 'SET_OVERALL_VOLUME_PLACES'
export const SET_OVERALL_VOLUME_WEIGHT = 'SET_OVERALL_VOLUME_WEIGHT'
export const SET_OVERALL_VOLUME_VOLUME = 'SET_OVERALL_VOLUME_VOLUME'
export const SET_SIZE_LENGTH_VALUE = 'SET_SIZE_LENGTH_VALUE'
export const SET_SIZE_WIDTH_VALUE = 'SET_SIZE_WIDTH_VALUE'
export const SET_SIZE_HEIGHT_VALUE = 'SET_SIZE_HEIGHT_VALUE'
export const SET_SIZE_WEIGHT_VALUE = 'SET_SIZE_WEIGHT_VALUE'
export const SET_SIZE_COUNTER_VALUE = 'SET_SIZE_COUNTER_VALUE'
export const ADD_SIZE_ITEM = 'ADD_SIZE_ITEM'
export const REMOVE_SIZE_ITEM = 'REMOVE_SIZE_ITEM'
export const SHOW_LOADER = 'SHOW_LOADER'
export const HIDE_LOADER = 'HIDE_LOADER'
export const TICKETS_REQUEST = 'TICKETS_REQUEST'
export const CHOSE_TICKET = 'CHOSE_TICKET'
export const CLOSE_TICKET = 'CLOSE_TICKET'
export const SET_ADV_EXPORT_VALUE = 'SET_ADV_EXPORT_VALUE'
export const SET_ADV_IMPORT_VALUE = 'SET_ADV_IMPORT_VALUE'
export const SET_ADV_STRAH_VALUE = 'SET_ADV_STRAH_VALUE'
export const SET_ADV_TERMINAL_START_VALUE = 'SET_ADV_TERMINAL_START_VALUE'
export const SET_ADV_TERMINAL_FINISH_VALUE = 'SET_ADV_TERMINAL_FINISH_VALUE'
export const SET_ADV_RAZM_START_VALUE = 'SET_ADV_RAZM_START_VALUE'
export const SET_ADV_RAZM_FINISH_VALUE = 'SET_ADV_RAZM_FINISH_VALUE'
export const SET_ADV_ADRESS_START_VALUE = 'SET_ADV_ADRESS_START_VALUE'
export const SET_ADV_ADRESS_FINISH_VALUE = 'SET_ADV_ADRESS_FINISH_VALUE'
export const SET_ADV_STRAH_VALUE_VALUE = 'SET_ADV_STRAH_VALUE_VALUE'
export const SET_ADV_ADRESS_START_VALUE_VALUE = 'SET_ADV_ADRESS_START_VALUE_VALUE'
export const SET_ADV_ADRESS_FINISH_VALUE_VALUE = 'SET_ADV_ADRESS_FINISH_VALUE_VALUE'
export const SET_CARGO_NAME_VALUE = 'SET_CARGO_NAME_VALUE'
export const SHOW_REQUEST_POPUP = 'SHOW_REQUEST_POPUP'
export const CLOSE_REQUEST_POPUP = 'CLOSE_REQUEST_POPUP'
export const SET_USER_PHONE_VALUE = 'SET_USER_PHONE_VALUE'
export const SET_USER_EMAIL_VALUE = 'SET_USER_EMAIL_VALUE'
export const REQUEST_ERROR = 'REQUEST_ERROR'
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS'
export const REQUEST_SUCCESS_CLOSE = 'REQUEST_SUCCESS_CLOSE'
export const CALC_EMPTY_ERROR = 'CALC_EMPTY_ERROR'
export const ERROR_CITY_FROM = 'ERROR_CITY_FROM'
export const ERROR_CITY_TO = 'ERROR_CITY_TO'
export const ERROR_DEPARTURE_DATE = 'ERROR_DEPARTURE_DATE'
export const ERROR_CARGO_TYPE = 'ERROR_CARGO_TYPE'
export const ERROR_OVERALL_VOLUME_PLACES = 'ERROR_OVERALL_VOLUME_PLACES'
export const ERROR_OVERALL_VOLUME_WEIGHT = 'ERROR_OVERALL_VOLUME_WEIGHT'
export const ERROR_OVERALL_VOLUME_VOLUME = 'ERROR_OVERALL_VOLUME_VOLUME'
export const ERROR_SIZES = 'ERROR_SIZES'
export const ERROR_CARGO_NAME = 'ERROR_CARGO_NAME'
export const ERROR_REQUEST_USER_PHONE = 'ERROR_REQUEST_USER_PHONE'
export const ERROR_REQUEST_USER_EMAIL = 'ERROR_REQUEST_USER_EMAIL'
export const SET_MAILING = 'SET_MAILING'
export const SET_PROCESSING = 'SET_PROCESSING'
